<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <div
        v-bind:class="getClassNameItem"
        v-for="(item,index) in getInformation"
        v-bind:key="index">                
        <span class="matrix_informationLabel">{{$t(item.label)}}</span>:<span class="matrix_informationValue">{{item.value}}</span>
    </div>
</div>

